import type { ValorantAgentRole } from 'generated/openapi';
import { memo, type SVGProps } from 'react';

import QuestionMarkIcon from '@/assets/icons/question-mark.svg?react';

import ControllerIcon from './icons/controller.svg?react';
import DuelistIcon from './icons/duelist.svg?react';
import InitiatorIcon from './icons/initiator.svg?react';
import SentinelIcon from './icons/sentinel.svg?react';

export interface ValorantRoleIconProps extends SVGProps<SVGSVGElement> {
  role?: ValorantAgentRole;
}

const roleIcons = {
  CONTROLLER: ControllerIcon,
  DUELIST: DuelistIcon,
  INITIATOR: InitiatorIcon,
  SENTINEL: SentinelIcon,
} as const;

export const ValorantRoleIcon = memo(function ValorantRoleIcon(
  props: ValorantRoleIconProps,
) {
  const { role, ...rest } = props;
  const Icon = role ? roleIcons[role] : QuestionMarkIcon;

  return <Icon {...rest} />;
});
